import { render } from "./Bills.vue?vue&type=template&id=2eef33ec"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__